(function() {
  var container = document.getElementById('rgInlineVariants');
  if (!container) return;

  var cards = container.querySelectorAll('.rg-iv');

  // Find section - try multiple approaches
  var mainSection = document.querySelector('[id*="__main"]') ||
                    container.closest('.shopify-section') ||
                    document;

  // Parse product JSON
  var variants = [];
  var scriptTag = document.querySelector('script[data-product-json]');
  if (scriptTag) {
    try { variants = JSON.parse(scriptTag.textContent).variants || []; } catch(e) {}
  }

  // Sold-out label (localized per store via data-soldout-label; falls back to English)
  var soldoutLabel = container.getAttribute('data-soldout-label') || 'Sold out';

  // Inject sold-out styling once (keeps behaviour consistent across stores/branches)
  if (!document.getElementById('rgIvSoldoutStyle')) {
    var st = document.createElement('style');
    st.id = 'rgIvSoldoutStyle';
    st.textContent =
      '.rg-iv--soldout{cursor:not-allowed}' +
      '.rg-iv--soldout:hover{border-color:#E8D0D1;box-shadow:none}' +
      '.rg-iv--soldout .rg-iv__img{opacity:.4;filter:grayscale(40%)}' +
      '.rg-iv--soldout .rg-iv__name,.rg-iv--soldout .rg-iv__detail,.rg-iv--soldout .rg-iv__save,.rg-iv--soldout .rg-iv__prices{opacity:.45}' +
      '.rg-iv--soldout .rg-iv__badge{display:none}' +
      '.rg-iv--soldout .rg-iv__check{display:none!important}' +
      '.rg-iv__soldout{position:absolute;top:-10px;left:50%;transform:translateX(-50%);background:#8a7d76;color:#fff;font-size:.65rem;font-weight:600;padding:2px 10px;border-radius:20px;letter-spacing:.5px;white-space:nowrap;text-transform:uppercase;z-index:2}';
    document.head.appendChild(st);
  }

  function findVariant(name) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].title === name || variants[i].option1 === name) return variants[i];
    }
    return null;
  }

  function isAvailable(card) {
    var v = findVariant(card.getAttribute('data-variant-name'));
    // Unknown variant defaults to available so the card is never wrongly blocked
    return v ? v.available !== false : true;
  }

  function firstAvailableCard() {
    for (var i = 0; i < cards.length; i++) {
      if (isAvailable(cards[i])) return cards[i];
    }
    return null;
  }

  function formatPrice(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return whole + ',' + parts[1] + ' kr';
  }

  // Reflect real stock on each card: grey it out + add a sold-out badge
  function applyAvailability() {
    cards.forEach(function(card) {
      var avail = isAvailable(card);
      card.classList.toggle('rg-iv--soldout', !avail);
      card.setAttribute('aria-disabled', avail ? 'false' : 'true');
      var lbl = card.querySelector('.rg-iv__soldout');
      if (!avail) {
        if (!lbl) {
          lbl = document.createElement('span');
          lbl.className = 'rg-iv__soldout';
          card.insertBefore(lbl, card.firstChild);
        }
        lbl.textContent = soldoutLabel;
        card.classList.remove('selected');
      } else if (lbl) {
        lbl.parentNode.removeChild(lbl);
      }
    });
  }

  // Disable the add-to-cart button(s) when the whole product is out of stock
  function setAddToCartSoldOut() {
    var btns = document.querySelectorAll('form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [type="submit"], button[name="add"]');
    btns.forEach(function(btn) {
      btn.setAttribute('disabled', 'disabled');
      btn.disabled = true;
      // Swap the label to "sold out" only when the button is plain text
      if (btn.children.length === 0) btn.textContent = soldoutLabel;
    });
  }

  function selectCard(card) {
    var name = card.getAttribute('data-variant-name');
    var variant = findVariant(name);
    if (!variant) return;

    // Never select a sold-out variant
    if (variant.available === false) return;

    // 1. Visual state
    cards.forEach(function(c) { c.classList.remove('selected'); });
    card.classList.add('selected');

    // 2. Update form
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function(input) {
      input.value = variant.id;
    });

    // 3. URL
    var url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    // 4. Update price display — handle Sense's dual price structure
    var priceContainer = mainSection.querySelector('.price');
    if (priceContainer) {
      var hasSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      // Always update the regular price (shown when not on sale)
      var regPrice = priceContainer.querySelector('.price__regular .price-item--regular');
      if (regPrice) regPrice.textContent = formatPrice(variant.price);

      // Always update the sale price
      var salePrice = priceContainer.querySelector('.price__sale .price-item--sale');
      if (salePrice) salePrice.textContent = formatPrice(variant.price);

      // Update the compare-at (strikethrough) price
      var comparePrice = priceContainer.querySelector('.price__sale s .price-item--regular');
      if (comparePrice) {
        comparePrice.textContent = hasSale ? formatPrice(variant.compare_at_price) : '';
      }

      // Toggle sale class
      if (hasSale) {
        priceContainer.classList.add('price--on-sale');
      } else {
        priceContainer.classList.remove('price--on-sale');
      }
    }

    // 5. Update ATC button price — Section Store uses <section-store--atc-text>
    var atcText = mainSection.querySelector('section-store--atc-text');
    if (atcText) {
      var priceMatch = atcText.textContent.match(/[\d.]+,\d{2}\s*kr/);
      if (priceMatch) {
        // Walk text nodes to find and replace the price
        var walker = document.createTreeWalker(atcText, NodeFilter.SHOW_TEXT, null, false);
        var node;
        while (node = walker.nextNode()) {
          if (/[\d.]+,\d{2}\s*kr/.test(node.textContent)) {
            node.textContent = node.textContent.replace(/[\d.]+,\d{2}\s*kr/, formatPrice(variant.price));
          }
        }
      }
    }
    // Fallback: try standard button
    var stdBtn = mainSection.querySelector('button[name="add"]');
    if (stdBtn && !atcText) {
      var walker = document.createTreeWalker(stdBtn, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while (node = walker.nextNode()) {
        if (/[\d.]+,\d{2}\s*kr/.test(node.textContent)) {
          node.textContent = node.textContent.replace(/[\d.]+,\d{2}\s*kr/, formatPrice(variant.price));
        }
      }
    }
    // Also update compare-at in button (strikethrough)
    if (stdBtn) {
      var btnStrike = stdBtn.querySelector('s, del');
      if (btnStrike && variant.compare_at_price) {
        var sw = document.createTreeWalker(btnStrike, NodeFilter.SHOW_TEXT, null, false);
        var sn;
        while (sn = sw.nextNode()) {
          if (/[\d.]+,\d{2}\s*kr/.test(sn.textContent)) {
            sn.textContent = sn.textContent.replace(/[\d.]+,\d{2}\s*kr/, formatPrice(variant.compare_at_price));
          }
        }
      }
    }

    // 6. Update Klarna — target by ID for reliability
    var klarnaEl = document.getElementById('rgKlarnaPrice');
    if (klarnaEl) {
      var monthly = Math.round(variant.price / 100 / 3);
      klarnaEl.textContent = monthly.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr/md';
    }

    // 7. Trigger native Shopify variant picker
    mainSection.querySelectorAll('variant-radios input[type="radio"]').forEach(function(radio) {
      if (radio.value === name) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    mainSection.querySelectorAll('variant-selects select').forEach(function(sel) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].text.trim() === name) {
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    });
  }

  // Reflect current stock before wiring interaction
  applyAvailability();

  // Click handlers (selectCard ignores sold-out variants)
  cards.forEach(function(card) {
    card.addEventListener('click', function() { selectCard(card); });
  });

  // Auto-select on load
  var urlVariantId = new URLSearchParams(window.location.search).get('variant');
  var initialCard = null;

  if (urlVariantId) {
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === urlVariantId) {
        cards.forEach(function(c) {
          if (c.getAttribute('data-variant-name') === variants[i].option1) initialCard = c;
        });
        break;
      }
    }
  }

  // Never default to a sold-out variant; prefer the URL one only if it is in stock
  if (!initialCard || !isAvailable(initialCard)) {
    initialCard = firstAvailableCard();
  }

  setTimeout(function() {
    if (initialCard) {
      selectCard(initialCard);
    } else {
      // Every variant is sold out — block purchasing entirely
      setAddToCartSoldOut();
    }
  }, 200);
})();
